// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"fc358e0e","163":"6d32a7e8","419":"0e801b64","563":"95c75c7e","787":"60d5b9ae"}[chunkId] + ".chunk.js";
};